import React from 'react';
import { trackAddToCartAndRedirect } from '../utils/metaPixel';
export function ValueStack() {
  return <section id="checkout" className="bg-brand-black py-20 px-4 text-white" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <div className="text-center mb-12" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-montserrat font-extrabold mb-4" data-id="element-199">
            Everything You Need To Sleep Soundly Tonight
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-200">
            Instant digital access. Start preparing in the next 5 minutes.
          </p>
        </div>

        <div className="bg-zinc-800/50 border border-zinc-700 rounded-2xl p-6 md:p-10 mb-12" data-id="element-201">
          <ul className="space-y-4 mb-8 text-lg md:text-xl font-opensans" data-id="element-202">
            <li className="flex justify-between items-center border-b border-zinc-700/50 pb-4" data-id="element-203">
              <span data-id="element-204">The Urban Autonomy Blueprint (Master Guide)</span>
              <span className="font-bold text-zinc-400" data-id="element-205">$197 Value</span>
            </li>
            <li className="flex justify-between items-center border-b border-zinc-700/50 pb-4" data-id="element-206">
              <span data-id="element-207">Bonus #1: Get Home Bag (Mobile Guide)</span>
              <span className="font-bold text-zinc-400" data-id="element-208">$97 Value</span>
            </li>
            <li className="flex justify-between items-center border-b border-zinc-700/50 pb-4" data-id="element-209">
              <span data-id="element-210">Bonus #2: Medical 911 (Emergency Guide)</span>
              <span className="font-bold text-zinc-400" data-id="element-211">$97 Value</span>
            </li>
            <li className="flex justify-between items-center pb-4" data-id="element-212">
              <span data-id="element-213">Bonus #3: Grey Man Protocol (Security Guide)</span>
              <span className="font-bold text-zinc-400" data-id="element-214">$67 Value</span>
            </li>
          </ul>
          <div className="flex flex-col md:flex-row justify-between items-center bg-zinc-900 p-6 rounded-xl border border-brand-orange/30" data-id="element-215">
            <div className="text-center md:text-left mb-4 md:mb-0" data-id="element-216">
            <p className="text-2xl md:text-4xl font-montserrat font-regular text-white" data-id="element-217">
                Be Ready Without Overcomplicating It
              </p>
              <p className="text-zinc-400 text-lg mb-1" data-id="element-218">
                TOTAL VALUE: <span className="line-through" data-id="element-219">$458.00</span>
              </p>
              <p className="text-3xl md:text-4xl font-montserrat font-extrabold text-white" data-id="element-220">
                YOURS TODAY: <span className="text-brand-orange" data-id="element-221">$9.99</span>
              </p>
            </div>
            <div className="text-right" data-id="element-222">
              <p className="text-green-400 font-bold text-lg animate-pulse" data-id="element-223">
                Save $448.01 (97% OFF)
              </p>
              
            </div>
                 </div>
        </div>

        <div id="checkout-cta" className="mb-12 relative w-full max-w-2xl mx-auto" data-id="element-224">
          <div className="absolute -inset-10 bg-brand-orange/10 blur-3xl rounded-full opacity-50" data-id="element-225"></div>
          <img src="https://cdn.magicpatterns.com/uploads/81v3Z22mjXq1UqGXTqYYLB/mockup_juntos.png" alt="The Ultimate Urban Autonomy Bundle" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-226" />
        </div>

        <div className="text-center" data-id="element-227">
          <a href="https://pay.hotmart.com/X104929887V?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={trackAddToCartAndRedirect} className="btn-crunchy block w-full md:w-auto px-12 py-6 text-xl md:text-2xl mx-auto mb-6" data-id="element-228">
            GIVE ME INSTANT ACCESS - ONLY $9.99
          </a>
          <p className="text-zinc-500 text-sm" data-id="element-229">
            One-time payment. No hidden fees. Instant digital delivery.
          </p>
        </div>
      </div>
    </section>;
}